import type { PortfolioSkimField, SkimEntity, SkimHit } from '@d3/contract';

import type { PortfolioSearchHit, PortfolioSearchItem } from '../model/portfolio-search';

function datetimeOf(hit: SkimHit): string {
  if (hit.period) return `${hit.period.year}.${hit.period.quarter}Q`;
  return hit.date ? hit.date.replaceAll('-', '.') : '';
}

/** skimmer 응답(포트폴리오별 묶음) → 검색 결과 뷰모델 */
export function toPortfolioSearchItem(entity: SkimEntity): PortfolioSearchItem {
  return {
    idx: entity.id,
    name: entity.name,
    nameMatched: entity.nameMatched,
    hits: entity.hits.map((hit): PortfolioSearchHit => ({
      field: hit.field as PortfolioSkimField,
      content: hit.value,
      datetime: datetimeOf(hit),
    })),
  };
}
